import { useState } from 'react';

import { Flex, Tabs, Typography, Spin, Alert } from 'antd';

const { Text } = Typography;

type TProps = {
	isAnswerLoading?: boolean;
	isResultsLoading?: boolean;
	answer?: string;
	resultsSummary?: string;
	error?: string;
};

export default function QAResults({ isAnswerLoading, isResultsLoading, answer, resultsSummary, error }: TProps) {
	const [activeTab, setActiveTab] = useState<'answer' | 'results'>('answer');

	if (error) {
		return (
			<Flex
				vertical
				gap={16}
				style={{
					border: '1px solid #d9d9d9',
					borderRadius: 8,
					padding: 16,
					//width: '100%',
				}}
			>
				<Alert
					message="Error"
					description={error}
					type="error"
					showIcon
				/>
			</Flex>
		);
	}

	// Always show the component - don't return null

	return (
		<Flex
			vertical
			gap={16}
			style={{
				border: '1px solid #d9d9d9',
				borderRadius: 8,
				padding: 16,
				//width: '100%',
			}}
		>
			<Tabs
				style={{ width: '100%' }}
				activeKey={activeTab}
				onChange={(key) => setActiveTab(key as 'answer' | 'results')}
				items={[
					{
						key: 'answer',
						label: 'Answer',
						children: (
					<Flex vertical gap={12} style={{ minHeight: 200 }}>
						{isAnswerLoading ? (
							<Flex align="center" gap={8}>
								<Spin size="small" />
								<Text type="secondary">Generating AI answer...</Text>
							</Flex>
						) : (
							<Text style={{ lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
								{answer || 'No answer available yet. Ask a question to get started.'}
							</Text>
						)}
					</Flex>
						),
					},
			{
				key: 'results',
				label: 'Results summary',
				children: (
					<Flex vertical gap={12} style={{ minHeight: 200 }}>
						{isResultsLoading ? (
							<Flex align="center" gap={8}>
								<Spin size="small" />
								<Text type="secondary">Generating AI summary...</Text>
							</Flex>
						) : (
							<Text style={{ lineHeight: 1.6, whiteSpace: 'pre-wrap' }}>
								{resultsSummary || 'No results summary available yet. Perform a search to get started.'}
							</Text>
						)}
					</Flex>
				),
			},
				]}
			/>
		</Flex>
	);
}
